import { useEffect, useState } from 'react';
import { Button, CardBody, Col, Input, Label, Row } from 'reactstrap';
import { SearchInputFilter } from '../../../Components/Custom/SearchInputFilter';
import { SearchSubmitButton } from '../../../Components/Custom/SearchSubmitButton';

import { useAppDispatch, useAppSelector } from '../../../app/hooks';

import { updateSumSubVerification } from './slice';

export const GetUserById = ({
  userId,
  setUserId,
  remark,
  setRemark
}: {
  setUserId: any;
  userId: string;
  remark: string;
  setRemark: any;
}) => {
  const dispatch = useAppDispatch();

  const handleSearchUser = async (e: any) => {
    e.preventDefault();
    try {
      await dispatch(
        updateSumSubVerification({ id: Number(userId), remark })
      ).unwrap();
      setUserId('');
      setRemark('');
    } catch {
      // error is already handled/toasted in the thunk
    }
  };

  return (
    <>
      <form onSubmit={handleSearchUser}>
        <CardBody className='border border-dashed border-end-0 border-start-0'>
          <Row>
            <Col md={3} sm={4}>
              <SearchInputFilter
                placeholder={'User ID'}
                onChange={({ target }: any) => setUserId(target.value)}
                value={userId}
              />
            </Col>
            <Col md={3} sm={4}>
              <button
                type='submit'
                className='btn btn-outline-danger waves-effect waves-light'>
                Verify
              </button>
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <Input
                id='title'
                className='w-100 mb-2'
                type='textarea'
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder='Remark'
              />
            </Col>
          </Row>
        </CardBody>
      </form>
    </>
  );
};
